import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

function PercorsoImage({ image }) {
    return (
        <div className="relative w-full h-full overflow-hidden rounded-md">
            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent" />
            <img src={image.src} alt={image.alt} className="w-full h-full object-cover" />
            {image.title && (
                <>
                    <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent" />
                    <div className="absolute bottom-0 left-0 w-full p-6">
                        <h3 className="font-bold text-3xl panoragraf-light uppercase text-mcare mb-2">{image.title}</h3>
                        <p className="text-white text-xl text-balance">{image.description}</p>
                    </div>
                </>
            )}
        </div>
    );
}

export default function Percorso({
    title,
    subtitle,
    tags,
    img1,
    alt1,
    imgTitle1,
    imgDescription1,
    img2,
    alt2,
    imgTitle2,
    imgDescription2,
    img3,
    alt3,
    imgTitle3,
    imgDescription3,
}) {
    const images = [
        { src: img1, alt: alt1, title: imgTitle1, description: imgDescription1 },
        { src: img2, alt: alt2, title: imgTitle2, description: imgDescription2 },
        { src: img3, alt: alt3, title: imgTitle3, description: imgDescription3 },
    ];

    return (
        <section className="min-h-screen text-white flex flex-col overflow-hidden py-10">
            <div className="text-center shrink-0 px-6">
                <h2 className="text-4xl md:text-5xl font-semibold text-mcare mb-8">{title}</h2>
                <p className=" text-lg  w-full md:w-1/2 mx-auto">{subtitle}</p>
            </div>
            <div className="flex justify-center text-2xl font-bold mt-10 shrink-0 px-6">
                <p className="flex flex-col md:flex-row flex-wrap items-center justify-center gap-2 md:gap-3 text-center">
                    {tags.map((tag, index) => (
                        <span key={index} className="flex items-center gap-3">
                            {index > 0 && <span className="hidden md:inline">-</span>}
                            {tag}
                        </span>
                    ))}
                </p>
            </div>

            <div className="mt-10 px-4 md:px-20 flex-1 min-h-0">
                {/* Desktop grid */}
                <div className="hidden md:grid grid-cols-3 gap-10 h-full">
                    {images.map((image, index) => (
                        <PercorsoImage key={index} image={image} />
                    ))}
                </div>

                {/* Mobile slider */}
                <div className="block md:hidden h-full">
                    <Swiper
                        slidesPerView={1}
                        spaceBetween={20}
                        autoplay={{
                            delay: 3500,
                            disableOnInteraction: false,
                            pauseOnMouseEnter: true,
                        }}
                        pagination={{
                            dynamicBullets: true,
                            clickable: true,
                        }}
                        modules={[Autoplay, Pagination]}
                        className="w-full h-full"
                    >
                        {images.map((image, index) => (
                            <SwiperSlide key={index} className="h-full">
                                <PercorsoImage image={image} />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </section>
    );
}